import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "iodine-icon-container" }

import { storeToRefs } from 'pinia';
import { GrouperLayoutMode } from 'src/services/IodineGrouperService';
import { useLayoutStore } from 'stores/layout-store';


export default /*#__PURE__*/_defineComponent({
  __name: 'GrouperTitle',
  setup(__props) {

const layoutStore = useLayoutStore();
const { layoutMode }  = storeToRefs(layoutStore);
const onClose = () => {
  layoutStore.requestClose();
}

const onExpandCollapse = () => {
  layoutStore.changeMode(layoutMode.value == GrouperLayoutMode.consolidated ? GrouperLayoutMode.fullScreen : GrouperLayoutMode.consolidated);
};


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_bar = _resolveComponent("q-bar")!

  return (_openBlock(), _createBlock(_component_q_bar, { class: "io-mfe-ig-title-bar" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_q_icon, {
          name: "fa-solid fa-layer-group",
          class: "io-mfe-ig-icon-medium"
        })
      ]),
      _createVNode(_component_q_toolbar_title, null, {
        default: _withCtx(() => [
          _createTextVNode("Encoder")
        ]),
        _: 1
      }),
      _createVNode(_component_q_btn, {
        class: "io-mfe-ig-icon-button-medium",
        round: "",
        onClick: onExpandCollapse
      }, {
        default: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_icon, { name: "fa-solid fa-compress" }, null, 512), [
            [_vShow, _unref(layoutMode) === _unref(GrouperLayoutMode).fullScreen]
          ]),
          _withDirectives(_createVNode(_component_q_icon, { name: "fa-solid fa-expand" }, null, 512), [
            [_vShow, _unref(layoutMode) === _unref(GrouperLayoutMode).consolidated]
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_q_btn, {
        class: "io-mfe-ig-icon-button-medium",
        round: "",
        onClick: onClose
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_icon, { name: "fa-solid fa-xmark" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})